import script from "./AgoraVideoCall.vue?vue&type=script&setup=true&lang=js"
export * from "./AgoraVideoCall.vue?vue&type=script&setup=true&lang=js"

import "./AgoraVideoCall.vue?vue&type=style&index=0&id=19ad677d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ad677d"]])

export default __exports__